import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function LinkedInCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");

  useEffect(() => {
    if (code) {
      handleLinkedInCallback(code);
    } else {
      navigate("/Profil");
    }
  }, [code, navigate]);

  const handleLinkedInCallback = async (code) => {
    try {

      const linkedInUser = await exchangeCodeForUserData(code);

      const requestBody = {
        adi: linkedInUser.firstName,
        soyadi: linkedInUser.lastName,
        email: linkedInUser.email,
        password: linkedInUser.id,
        saglayiciId: linkedInUser.id,
        saglayici: "linkedin",
      };

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const resultText = await response.text();
      let data;

      try {
        data = JSON.parse(resultText);
      } catch (e) {
        data = { message: resultText };
      }

      if (response.ok || data.message?.includes("zaten kayıtlı")) {
        const user = data.user || {
          adi: linkedInUser.firstName,
          soyadi: linkedInUser.lastName,
          email: linkedInUser.email,
        };

        localStorage.setItem(
          "user",
          JSON.stringify({
            adi: user.adi,
            soyadi: user.soyadi,
            email: user.email,
            token: data.token?.result || "",
          })
        );

        navigate("/profil");
      } else {
        console.error("API Hatası:", data.message || data);
        alert("❌ Giriş başarısız: " + (data.message || "Bilinmeyen hata"));
        navigate("/Profil");
      }
    } catch (error) {
      console.error("LinkedIn callback hatası:", error);
      alert("❌ LinkedIn ile giriş başarısız.");
      navigate("/Profil");
    }
  };


  const exchangeCodeForUserData = async (code) => {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/linkedin`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code }),
    });

    if (!response.ok) {
      throw new Error("LinkedIn token alınamadı.");
    }

    return await response.json();
  };

  return <h2>LinkedIn ile giriş yapılıyor, lütfen bekleyin...</h2>;
}